const at = name => `[data-tour-scope="customers-list"] [data-tour="${name}"]`;
const visible = selector => {
	const element = document.querySelector(selector);
	return !!element && element.getClientRects().length > 0;
};
const pause = () => new Promise(resolve => setTimeout(resolve, 0));

async function openMenu(activator, probe) {
	await pause();
	if (!visible(probe)) document.querySelector(activator)?.click();
}

export function stopCustomersListTour() {
	for (const [activator, probe] of [[at('add'), at('add-customer')], [at('row-menu'), at('row-edit')]]) {
		if (visible(probe)) document.querySelector(activator)?.click();
	}
}

export function createCustomersListTourSteps() {
	return [
		{ body: 'Qui gestisci clienti privati e aziende, i loro indirizzi, il listino assegnato e il credito wallet.', key: 'intro', placement: 'bottom', target: at('tutorial'), title: 'Gestire i clienti' },
		{ body: 'Cerca per anagrafica o contatti e restringi i risultati per listino e tipologia cliente.', key: 'filters', placement: 'bottom', target: at('filters'), title: 'Ricerca e filtri' },
		{ before: () => openMenu(at('add'), at('add-customer')), body: 'Apri Aggiungi cliente per compilare anagrafica, spedizione e fatturazione con il tutorial dedicato.', key: 'add', placement: 'left', target: at('add-customer'), timeout: 250, title: 'Nuovo cliente' },
		{ body: 'La tabella mostra stato, tipologia, dati del cliente, azienda, P.IVA, listino e saldo wallet.', key: 'table', placement: 'top', target: at('table'), title: 'Elenco clienti' },
		{ body: 'L’interruttore abilita o disabilita rapidamente il cliente.', key: 'status', missing: 'skip', placement: 'right', target: at('status'), title: 'Stato cliente' },
		{ before: () => openMenu(at('row-menu'), at('row-edit')), body: 'I tre pallini aprono la scheda di modifica del singolo cliente.', key: 'row-menu', placement: 'right', target: at('row-edit'), timeout: 250, title: 'Modificare un cliente' },
	];
}
